var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Watch } from 'vue-property-decorator';
import RegexStr from "../../common/RegexStr";
import sourceDic from '../../helper/sourceDic';
import VueDialog from "../../interface/IVueDialog";
import ClientService from "../../api/ClientService";
import CommonService from "../../api/CommonService";
import CompanyService from "../../api/CompanyService";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
import Uploader from "../../common/components/uploader";
var phoneRegex = new RegExp(RegexStr.phone);
var ACCOUNT_DATE_TYPE;
(function (ACCOUNT_DATE_TYPE) {
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["ADVANCE_PAYMENT"] = 10] = "ADVANCE_PAYMENT";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DELIVERY_PAYMENT_ONLINE"] = 11] = "DELIVERY_PAYMENT_ONLINE";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DELIVERY_PAYMENT_OFFLINE"] = 12] = "DELIVERY_PAYMENT_OFFLINE";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["DALIILY"] = 13] = "DALIILY";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["WEEKS"] = 14] = "WEEKS";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["MONTHLY_PAYMENT"] = 15] = "MONTHLY_PAYMENT";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["SEASON"] = 16] = "SEASON";
    ACCOUNT_DATE_TYPE[ACCOUNT_DATE_TYPE["OFFLINE_ADVANCE_PAYMENT"] = 17] = "OFFLINE_ADVANCE_PAYMENT";
})(ACCOUNT_DATE_TYPE || (ACCOUNT_DATE_TYPE = {}));
var EditDialog = (function (_super) {
    __extends(EditDialog, _super);
    function EditDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.phoneRegex = phoneRegex;
        _this.categoryList = [];
        _this.formData = {
            business_name: "",
            business_cooperation_state: "",
            accountdatetype: "",
            contract_date: [{}, {}],
            business_contact: "",
            business_phone: '',
            business_city_id: null,
            business_address: '',
            group: '',
            organ_id: '',
            operation_type_id: [],
            freeze: '',
            edi_business_status: '',
            business_no: '',
            is_franchisee: '',
            join_date: [{}, {}],
            document_pic: [],
            business_level: '',
            ap_account_id: '',
            day_week: [],
            purchase_start_time: '',
            purchase_end_time: '',
            shipping_fee_dtid: '',
        };
        _this.joinOpen = false;
        _this.row = {};
        _this.groups = [];
        _this.organList = [];
        _this.customerSource = '1';
        _this.dayWeekOptions = [
            { name: '周日', id: 0 },
            { name: '周一', id: 1 },
            { name: '周二', id: 2 },
            { name: '周三', id: 3 },
            { name: '周四', id: 4 },
            { name: '周五', id: 5 },
            { name: '周六', id: 6 },
        ];
        _this.shippingFeeList = [];
        _this.isOpenShippingFee = false;
        _this.settlementList = [];
        _this.operation_type_ids = [];
        _this.operation_list = [];
        _this.account_date_options = [];
        _this.accountDateEnum = ACCOUNT_DATE_TYPE;
        _this.accountdateval = '';
        _this.businessCooperationOptions = [
            { name: '已合作', id: 0 },
            { name: '已暂停', id: 1 },
        ];
        _this.business_tel_list = [{}];
        _this.clientLevel = [];
        _this.saleUser = [];
        _this.isOpenApAccountTypeBusiness = false;
        return _this;
    }
    EditDialog.prototype.fileListWatch = function (val, old) {
        if (val == ACCOUNT_DATE_TYPE.WEEKS) {
            this.account_date_options = [1, 2, 3, 4, 5, 6, 7];
            this.formData.accountdateval = '';
        }
        else if (val == ACCOUNT_DATE_TYPE.MONTHLY_PAYMENT || val == ACCOUNT_DATE_TYPE.SEASON) {
            this.account_date_options = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
            this.formData.accountdateval = '';
        }
        else {
            this.account_date_options = [];
            this.formData.accountdateval = '';
        }
    };
    EditDialog.prototype.created = function () {
        var _this = this;
        this.service = ClientService.getInstance();
        this.commonService = CommonService.getInstance();
        this.companyService = CompanyService.getInstance();
        this.isOpenShippingFee = this.$data.isOpenShippingFee || false;
        var rowData = this.row;
        console.log(rowData, 999);
        var accountdateval = rowData.from_system == 1 ? rowData.accountdateval + '日' : rowData.accountdateval;
        var dayWeekData = [];
        var purchaseStartTime = '';
        var purchaseEndTime = '';
        if (rowData.purchase_time && rowData.purchase_time.purchase_time_id) {
            var purchaseTime = rowData.purchase_time;
            dayWeekData = purchaseTime.day_week ? purchaseTime.day_week.map(function (item) { return item.id; }) : [];
            purchaseStartTime = purchaseTime.s_time || '';
            purchaseEndTime = purchaseTime.e_time || '';
        }
        this.formData = {
            business_name: rowData.business_name,
            business_cooperation_state: rowData.business_cooperation_state,
            accountdatetype: rowData.accountdatetype + '',
            contract_date: rowData.cooperate_stime ? [new Date(rowData.cooperate_stime), new Date(rowData.cooperate_etime)] : '',
            business_contact: rowData.business_contact,
            business_phone: rowData.business_phone,
            business_city_id: rowData.business_city_id,
            business_address: rowData.business_address,
            group: rowData.group_id,
            source: sourceDic[rowData.from_system],
            accountdateval: accountdateval,
            organ_id: rowData.organ_id,
            operation_type_id: rowData.operation_type_id,
            ap_account_id: rowData.ap_account_id ? rowData.ap_account_id : '',
            freeze: rowData.freeze,
            edi_business_status: rowData.edi_business_status,
            business_no: rowData.business_no,
            is_franchisee: rowData.is_franchisee,
            join_date: rowData.franchisee_stime ? [new Date(rowData.franchisee_stime), new Date(rowData.franchisee_etime)] : '',
            document_pic: [],
            business_level: rowData.business_level,
            day_week: dayWeekData,
            purchase_start_time: purchaseStartTime,
            purchase_end_time: purchaseEndTime,
            shipping_fee_dtid: (rowData.shipping_fee_dtid && rowData.shipping_fee_dtid !== 0 && rowData.shipping_fee_dtid !== '0') ? rowData.shipping_fee_dtid : ''
        };
        this.$nextTick(function () {
            _this.formData.accountdateval = accountdateval;
            console.log('accountdateval=============', accountdateval);
        });
        if (rowData.customer_certificates_num !== 0) {
            this.getCertifucate();
        }
        this.formData.business_tel = rowData.business_tel;
        if (this.formData.business_tel) {
            var tel_list = this.formData.business_tel.split('、');
            this.business_tel_list = [];
            if (tel_list && tel_list.length) {
                tel_list.forEach(function (item) {
                    if (item) {
                        var tel = item.split('-');
                        if (tel && tel.length > 1) {
                            _this.business_tel_list.push({
                                business_tel_code: tel[0],
                                business_tel: tel[1]
                            });
                        }
                    }
                });
            }
        }
    };
    EditDialog.prototype.mounted = function () {
        var _this = this;
        this.service.getArea().then(function (res) {
            var data = res.data;
            if (data.success) {
                _this.categoryList = data.data[0].children;
                _this.formData.business_city_id = _this.row.business_city_id;
            }
            else {
                _this.$message.error(data.msg);
            }
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
        this.service.getGroups().then(function (res) {
            var data = res.data.data;
            _this.groups = data || [];
            if (data && data.length && !_this.formData.group) {
                _this.formData.group = data[0].group_id;
            }
        });
        this.getOrganList();
        this.getSettlementList();
        this.getOperationList();
        this.getClientLevel();
        this.getSaleUser();
        this.getShippingFeeList();
    };
    EditDialog.prototype.getSaleUser = function () {
        var _this = this;
        this.service.getSaleUser().then(function (res) {
            _this.saleUser = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    EditDialog.prototype.getClientLevel = function () {
        var _this = this;
        this.service.getClientLevel().then(function (res) {
            _this.clientLevel = Array.isArray(res.data.data) ? res.data.data : [];
            _this.clientLevel.unshift({
                id: -1,
                name: '无等级'
            });
        });
    };
    EditDialog.prototype.getCertifucate = function () {
        var _this = this;
        var params = {
            business_id: this.row.business_id
        };
        this.service.getCertificate(params).then(function (res) {
            _this.formData.document_pic = Array.isArray(res.data.data.customer_certificates) ? res.data.data.customer_certificates : [];
            var newData = [];
            _this.formData.document_pic.forEach(function (item, index) {
                newData.push({
                    url: item,
                });
            });
            _this.formData.document_pic = newData;
        });
    };
    EditDialog.prototype.getSettlementList = function () {
        var _this = this;
        this.companyService.getSettlementList().then(function (res) {
            _this.settlementList = res.data.data;
        }).catch(function (err) {
            _this.$message.error(err.message || err.msg);
        });
    };
    EditDialog.prototype.getOperationList = function () {
        var _this = this;
        this.service.getOperationList().then(function (res) {
            if (res.data.success) {
                _this.operation_list = res.data.data;
            }
        });
    };
    EditDialog.prototype.getOrganList = function () {
        var _this = this;
        this.commonService.getOrganList().then(function (res) {
            var data = res.data.data;
            _this.organList = data || [];
        });
    };
    EditDialog.prototype.getShippingFeeList = function () {
        var _this = this;
        this.service.getShippingFeeList().then(function (res) {
            if (res.data.success) {
                _this.shippingFeeList = res.data.data;
            }
        });
    };
    EditDialog.prototype.getShippingFeeName = function () {
        var _this = this;
        if (!this.formData.shipping_fee_dtid || this.formData.shipping_fee_dtid === 0 || this.formData.shipping_fee_dtid === '0')
            return '';
        var shippingFee = this.shippingFeeList.find(function (item) { return item.dtid == _this.formData.shipping_fee_dtid; });
        return shippingFee ? shippingFee.name : '';
    };
    EditDialog.prototype.sTimeBlur = function () {
        if (!this.formData.purchase_start_time || !this.formData.purchase_start_time.includes(':')) {
            this.formData.purchase_start_time = '00:00';
            return false;
        }
        if (this.formData.purchase_start_time) {
            this.formData.purchase_start_time = this.formData.purchase_start_time.replace('：', ':');
        }
        if (this.formData.purchase_start_time && !this.isTimeInRange(this.formData.purchase_start_time)) {
            this.formData.purchase_start_time = '00:00';
        }
    };
    EditDialog.prototype.eTimeBlur = function () {
        if (!this.formData.purchase_end_time || !this.formData.purchase_end_time.includes(':')) {
            this.formData.purchase_end_time = '23:59';
            return false;
        }
        if (this.formData.purchase_end_time) {
            this.formData.purchase_end_time = this.formData.purchase_end_time.replace('：', ':');
        }
        if (this.formData.purchase_end_time && !this.isTimeInRange(this.formData.purchase_end_time)) {
            this.formData.purchase_end_time = '23:59';
        }
        this.isEtimeValid();
    };
    EditDialog.prototype.isTimeInRange = function (time) {
        var regex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
        return regex.test(time);
    };
    EditDialog.prototype.isEtimeValid = function () {
        if (!this.formData.purchase_start_time || !this.formData.purchase_end_time) {
            return true;
        }
        var _a = this.formData.purchase_start_time.split(':').map(Number), sHour = _a[0], sMinute = _a[1];
        var _b = this.formData.purchase_end_time.split(':').map(Number), eHour = _b[0], eMinute = _b[1];
        if (eHour < sHour || (eHour === sHour && eMinute <= sMinute)) {
            this.$message.warning("结束时间必须大于开始时间");
            return false;
        }
        return true;
    };
    EditDialog.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (!res) {
                return false;
            }
            else {
                var formData = _this.formData;
                if (formData.business_no == '') {
                    _this.$message.error('客户编码不能为空');
                    return;
                }
                ;
                if (formData.day_week && formData.day_week.length > 0) {
                    if (!formData.purchase_start_time || !formData.purchase_end_time) {
                        _this.$message.error('选择了订货周期日，开始时间和结束时间不能为空');
                        return;
                    }
                    if (!_this.isEtimeValid()) {
                        return;
                    }
                }
                if (formData.business_phone != '' && !phoneRegex.test(formData.business_phone)) {
                    _this.$message.error('手机号格式不正确！');
                    return;
                }
                ;
                var is_franchisee = formData.is_franchisee;
                var franchisee_stime = formData.join_date && formData.join_date.length > 0 ? formData.join_date[0].format("yyyy-MM-dd") : '';
                var franchisee_etime = formData.join_date && formData.join_date.length > 0 ? formData.join_date[1].format("yyyy-MM-dd") : '';
                if (is_franchisee) {
                    if (!franchisee_stime) {
                        _this.$message.error('加盟开始时间不能为空');
                        return;
                    }
                    if (!franchisee_etime) {
                        _this.$message.error('加盟结束时间不能为空');
                        return;
                    }
                    if (franchisee_stime > franchisee_etime) {
                        _this.$message.error('加盟开始时间不能大于加盟结束时间');
                        return;
                    }
                }
                var business_tel = '';
                if (_this.business_tel_list && _this.business_tel_list.length) {
                    var business_tel_list_1 = [];
                    _this.business_tel_list.forEach(function (item) {
                        if (item.business_tel_code && item.business_tel) {
                            business_tel_list_1.push(item.business_tel_code + '-' + item.business_tel);
                        }
                    });
                    business_tel = business_tel_list_1.join('、');
                }
                var document_pic = [];
                if (formData.document_pic && formData.document_pic.length) {
                    document_pic = formData.document_pic.map(function (item) { return item.url; });
                }
                var params = {
                    supplier_to_business_id: _this.row.supplier_to_business_id,
                    business_id: _this.row.business_id,
                    business_contact: formData.business_contact,
                    business_phone: formData.business_phone,
                    business_city_id: formData.business_city_id,
                    business_address: formData.business_address,
                    cooperate_stime: formData.contract_date && formData.contract_date.length > 0 ? formData.contract_date[0].format("yyyy-MM-dd") : '',
                    cooperate_etime: formData.contract_date && formData.contract_date.length > 0 ? formData.contract_date[1].format("yyyy-MM-dd") : '',
                    group_id: _this.formData.group,
                    organ_id: _this.formData.organ_id,
                    business_name: _this.formData.business_name,
                    operation_type_ids: (_this.formData.operation_type_id || []).join(','),
                    ap_account_ids: _this.formData.ap_account_id,
                    accountdatetype: _this.formData.accountdatetype,
                    accountdateval: _this.formData.accountdateval,
                    business_cooperation_state: _this.formData.business_cooperation_state,
                    freeze: _this.formData.freeze,
                    edi_business_status: _this.formData.edi_business_status,
                    business_no: _this.formData.business_no,
                    is_franchisee: is_franchisee,
                    franchisee_stime: franchisee_stime,
                    franchisee_etime: franchisee_etime,
                    business_tel: business_tel,
                    customer_certificates: document_pic,
                    business_level: formData.business_level,
                    day_week: formData.day_week && formData.day_week.length > 0 ? formData.day_week.join(',') : '',
                    purchase_start_time: formData.purchase_start_time || '',
                    purchase_end_time: formData.purchase_end_time || '',
                    shipping_fee_dtid: (formData.shipping_fee_dtid && formData.shipping_fee_dtid !== '0') ? formData.shipping_fee_dtid : 0,
                    shipping_fee_dtid_name: _this.getShippingFeeName()
                };
                _this.service.editClient(params).then(function (res) {
                    if (res.data.success) {
                        if (res.data.code == 30) {
                            var instance = _this.$dialog(ArtMsglist, {
                                data: {
                                    msgData: res.data.data
                                }
                            }, {
                                title: "提示",
                                width: 450,
                                height: 350,
                                closeBtn: false,
                            }).instance;
                            instance.$on("addClient:ok", function (data) { });
                        }
                        else {
                            _this.$message.success('保存成功！');
                            _this.close();
                            _this.$emit('editClient:ok');
                        }
                    }
                    else {
                        _this.$message.error(res.data.msg);
                    }
                    ;
                }).catch(function (err) {
                    _this.$message.error(err.message);
                });
            }
        });
    };
    EditDialog.prototype.close = function () {
        this.$closeDialog();
    };
    EditDialog.prototype.normalizer = function (node) {
        return {
            id: node.id,
            label: node.name,
            children: node.children,
        };
    };
    EditDialog.prototype.addTel = function () {
        this.business_tel_list.push({});
    };
    EditDialog.prototype.delTel = function (index) {
        this.business_tel_list.splice(index, 1);
    };
    __decorate([
        Watch("formData.accountdatetype")
    ], EditDialog.prototype, "fileListWatch", null);
    EditDialog = __decorate([
        Component({
            components: {
                uploader: Uploader
            }
        })
    ], EditDialog);
    return EditDialog;
}(VueDialog));
export default EditDialog;
